<section *ngIf="!isPetDataValid">
  @if (mobileScreen) {
    <div class="medication-prescription-placeholder mobile-placeholder">
      <h3>Prescrição de Medicamentos</h3>
      <p class="placeholder-message">
        Selecione as <b>Características Clínicas</b> do <b>Pet</b> para a
        correta prescrição de medicamentos.
      </p>
    </div>
  } @else {
    <div class="medication-prescription-placeholder">
      <h3>Prescrição de Medicamentos</h3>
      <p class="placeholder-message">
        Selecione as <b>Características Clínicas</b> do <b>Pet</b> para a
        correta prescrição de medicamentos.
      </p>
    </div>
  }
</section>

<section class="medication-prescription-section" *ngIf="isPetDataValid">
  <div class="section-header">
    <h3 class="section-title">Prescrição de Medicamentos</h3>
  </div>

  <section class="prescription-options-container">
    <p>
      Adicione <strong>Medicamentos Comerciais</strong> (de farmácia) ou
      <strong>Manipulados</strong> à prescrição.
    </p>

    <div class="prescription-options-buttons">
      <button type="button">
        <img src="../../../../../assets/icons/plus.svg" alt="" />
        Comercial
      </button>

      <button type="button">
        <img src="../../../../../assets/icons/plus.svg" alt="" />
        Manipulado
      </button>
    </div>
  </section>
</section>
